var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "£{{amount}}";
Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') {
        cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
};

function quantityInput(element, options) {
    const spinner = element;

    const defaultOptions = {
        min: 1,
        max: 250,
        value: 1,
    };

    options = Object.assign({}, defaultOptions, options);

    const obj = {
        input: spinner.querySelector('input[type="text"]'),
        init() {
            this.setup();
            this.events();
            return this;
        },
        setup() {
            this.input.value = options.value;
            this.max = options.max;
            this.min = options.min;

            this.btnUp = spinner.querySelector('[data-control="plus"]');
            this.btnDown = spinner.querySelector('[data-control="minus"]');
        },
        trigger() {
            const event = document.createEvent('HTMLEvents');
            event.initEvent('change', true, false);
            return event;
        },
        events() {
            this.btnUp.addEventListener('click', () => {
                const oldValue = parseFloat(this.input.value);
                let newVal;
                if (oldValue >= this.max) {
                    newVal = oldValue;
                } else {
                    newVal = oldValue + 1;
                }

                this.input.value = newVal;
                this.input.dispatchEvent(this.trigger());
            });

            this.btnDown.addEventListener('click', () => {
                const oldValue = parseFloat(this.input.value);
                let newVal;
                if (oldValue <= this.min) {
                    newVal = oldValue;
                } else {
                    newVal = oldValue - 1;
                }
                this.input.value = newVal;
                this.input.dispatchEvent(this.trigger());
            });

            this.input.addEventListener('change', () => {
                if (parseInt(this.input.value, 16) < this.min) {
                    this.input.value = this.min;
                }
                if (parseInt(this.input.value, 16) > this.max) {
                    this.input.value = this.max;
                }
            });
        },
    }
    return obj.init();
}

function toggle(item, selectedClass) {
    const toggleItem = document.querySelectorAll(item);
    for (let i = 0; i < toggleItem.length; i++) {
        const thisItem = toggleItem[i];
        if (thisItem.classList.contains(selectedClass)) {
            thisItem.classList.remove(selectedClass)
        } else {
            thisItem.classList.add(selectedClass)
        }
    }
}

function getJSON(url, callback) {
    let xhr = new XMLHttpRequest;
    xhr.open("GET", url);
    xhr.send();
    xhr.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
            let regexStatus = /(\w+ state:.*?)</g,
                response = xhr.responseText;
            response = JSON.parse(response);
            if (callback) callback(response);
        } else {
            if (xhr.response) {
                // console.log(JSON.parse(xhr.response));
            }
        };
    }
};

document.addEventListener('click',function(e){
    let target_classes = e.target.getAttribute('class');
    if (e.target && target_classes != undefined) {
        if(target_classes.indexOf('product-grid-item_add') !== -1){
            e.preventDefault();
            var thisAddBtn = e.target;
            var thisVariant = thisAddBtn.dataset.variant;

            if (thisVariant != null) {
                let formData = {
                    'items': [{
                        'id': thisVariant,
                        'quantity': 1
                    }]
                };

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                })
                .then(response => {
                    thisAddBtn.innerHTML = 'Added!'
                    setTimeout(() => {
                        thisAddBtn.innerHTML = 'Add to Basket'
                    }, 1000);
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
            }
        }
    }
});


